import { motion } from "framer-motion";
import { Col, Row } from "react-bootstrap";
import { Item } from "./NestedPayerResponse";
import { useSelector } from "react-redux";
import moment from "moment";

const PreauthorizationEncounterNested = () => {
  const { preauthorizationRequest } = useSelector(
    (state) => state.preauthorization
  );

  const { claimRequestData } = useSelector((state) => state.claim);

  const cliamPreauthorization =
    preauthorizationRequest?.entry?.find(
      (e) => e.resource?.resourceType === "Claim"
    )?.resource ||
    claimRequestData?.entry?.find((e) => e.resource?.resourceType === "Claim")
      ?.resource;
  const preauthorizationEncounter =
    preauthorizationRequest?.entry?.find(
      (e) => e.resource?.resourceType === "Encounter"
    )?.resource ||
    claimRequestData?.entry?.find(
      (e) => e.resource?.resourceType === "Encounter"
    )?.resource;

  const getServiceEventTypeCode = (type) => {
    if (!Array.isArray(preauthorizationEncounter?.extension)) return "";

    const serviceEvent = preauthorizationEncounter.extension.find((ext) =>
      ext.url?.includes(type)
    );

    return (
      serviceEvent?.valueCodeableConcept?.coding?.[0]?.display ||
      serviceEvent?.valueCodeableConcept?.coding?.[0]?.code ||
      serviceEvent?.valueDateTime ||
      ""
    );
  };

  const getHospitalizationTypeCode = (type) => {
    const serviceEvent =
      preauthorizationEncounter?.hospitalization?.extension?.find((ext) =>
        ext.url?.includes(type)
      );

    return (
      serviceEvent?.valueCodeableConcept?.coding?.[0]?.display ||
      serviceEvent?.valueCodeableConcept?.coding?.[0]?.code ||
      serviceEvent?.valueDateTime ||
      ""
    );
  };

  const encounterTriageData = preauthorizationEncounter?.extension?.find(
    (item) => item?.url?.includes("extension-triageDate")
  )?.valueDateTime;

  const empolyImapct = cliamPreauthorization?.supportingInfo.find((entry) =>
    entry.category?.coding?.some(
      (coding) => coding.code === "employmentImpacted"
    )
  );

  const itemDetails = [
    {
      id: 1,
      title: "Triage Category",
      value: getServiceEventTypeCode("extension-triageCategory") || "",
    },
    {
      id: 1,
      title: "Emergency Arrival Code",
      value: getServiceEventTypeCode("extension-emergencyArrivalCode") || "",
    },
    {
      id: 1,
      title: "Emergency Department Disposition",
      value:
        getServiceEventTypeCode("extension-emergencyDepartmentDisposition") ||
        "",
    },
    {
      id: 1,
      title: "Emergency Service Date",
      value: getServiceEventTypeCode("extension-emergencyServiceStart")
        ? moment(
            getServiceEventTypeCode("extension-emergencyServiceStart")
          ).format("DD-MM-YYYY , hh:mm:ss A")
        : "",
    },
    {
      id: 1,
      title: "Cause Of Death",
      value: getServiceEventTypeCode("extension-causeOfDeath"),
    },
    {
      id: 3,
      title: "Encounter Class",
      value:
        encounterClasses[`${preauthorizationEncounter?.class?.code}`] || "",
    },
    {
      id: 4,
      title: "Encounter Status",
      value: preauthorizationEncounter?.status || "",
    },
    {
      id: 5,
      title: "Service Event Type",
      value:
        serviceEvent[
          `${getServiceEventTypeCode("extension-serviceEventType")}`
        ],
    },
    {},
    {
      id: 5,
      title: "Service Type",
      value: preauthorizationEncounter?.serviceType?.coding[0]?.code || "",
    },
    {
      id: 5,
      title: "Act Priorty",
      value:
        actPriorities[
          `${preauthorizationEncounter?.priority?.coding[0]?.code}`
        ] || "",
    },
    {
      id: 9,
      title: "Admission Specilaity",
      value: admissionSpeciality?.find(
        (item) =>
          item.specialities_code ===
          getHospitalizationTypeCode("admissionSpecialty")
      )?.specialities_name,
    },
    {
      id: 5,
      title: "Intend Length Of Stay",
      value:
        intendLength[
          `${getHospitalizationTypeCode("extension-intendedLengthOfStay")}`
        ] || "",
    },
    {
      id: 5,
      title: "Discharge Speciality",
      value: getHospitalizationTypeCode("extension-dischargeSpecialty") || "",
    },
    {
      id: 5,
      title: "Admit Source",
      value:
        admitSourceList?.find(
          (item) =>
            item?.enctalltyp_code ===
            preauthorizationEncounter?.hospitalization?.admitSource?.coding[0]
              ?.code
        )?.enctalltyp_name || "",
    },
    {
      id: 5,
      title: "Empolyment Impacted Period",
      value: empolyImapct?.timingPeriod
        ? `From ${empolyImapct?.timingPeriod?.start} To ${empolyImapct?.timingPeriod?.end}`
        : null,
    },
  ];

  return (
    <motion.div
      className="rounded p-3 position-relative mt-3 mb-3"
      style={{ border: "2px solid #d9f8eb" }}
      initial={{ opacity: 0, y: 50 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: 50 }}
      transition={{ duration: 0.5 }}
    >
      {/* Floating Badge Header */}
      <div className="position-absolute top-0 start-40 translate-middle-y px-2 d-none d-md-block">
        <span className="badge shadow-sm d-flex align-items-center justify-content-center gap-2 badge-subtle-success">
          <span className="fs-11">Encounter</span>
        </span>
      </div>

      {/* Dates Section */}
      <Row className="mt-3">
        {preauthorizationEncounter?.period?.start && (
          <Col xs={12} md={4}>
            <div className="d-flex gap-3">
              <span className="fw-bold fs-10">Admission Date</span>
              <span className="fw-normal text-600 fs-10">
                {moment(preauthorizationEncounter?.period?.start).format(
                  "DD-MM-YYYY , hh:mm:ss A"
                )}
              </span>
            </div>
          </Col>
        )}
        {preauthorizationEncounter?.period?.end && (
          <Col xs={12} md={4}>
            <div className="d-flex gap-3">
              <span className="fw-bold fs-10">Discharge Date</span>
              <span className="fw-normal text-600 fs-10">
                {moment(preauthorizationEncounter?.period?.end).format(
                  "DD-MM-YYYY , hh:mm:ss A"
                )}
              </span>
            </div>
          </Col>
        )}
        {encounterTriageData && (
          <Col xs={12} md={4}>
            <div className="d-flex gap-3">
              <span className="fw-bold fs-10">Triage Date</span>
              <span className="fw-normal text-400 fs-10">
                {encounterTriageData
                  ? moment(encounterTriageData).format(
                      "DD-MM-YYYY , hh:mm:ss A"
                    )
                  : ""}
              </span>
            </div>
          </Col>
        )}
      </Row>

      <hr />

      {/* Dynamic Info Section */}
      <Row>
        {itemDetails
          .filter((item) => item.value)
          .map((item) => (
            <Col key={item.id} xs={12} md={4} xl={3} className="mb-3">
              <Item title={item.title} value={item.value} />
            </Col>
          ))}
      </Row>
    </motion.div>
  );
};

export default PreauthorizationEncounterNested;

const actPriorities = {
  A: "ASAP",
  CR: "callback results",
  CS: "callback for scheduling",
  CSP: "callback placer for scheduling",
  CSR: "contact recipient for scheduling",
  EL: "elective",
  EM: "emergency",
  P: "preop",
  PRN: "as needed",
  R: "routine",
  RR: "rush reporting",
  S: "stat",
  T: "timing critical",
  UD: "use as directed",
  UR: "urgent",
};

const admitSourceList = [
  {
    enctalltyp_code: "IA",
    enctalltyp_name: "Immediate Admission",
  },
  {
    enctalltyp_code: "EER",
    enctalltyp_name: "Admission from hospital ER",
  },
  {
    enctalltyp_code: "EOP",
    enctalltyp_name: "Emergency Admission from hospital outpatient",
  },
  {
    enctalltyp_code: "EGPHC",
    enctalltyp_name:
      "Emergency Admission by referral from government primary healthcare center",
  },
  {
    enctalltyp_code: "EGGH",
    enctalltyp_name:
      "Emergency Admission by referral from general government hospital",
  },
  {
    enctalltyp_code: "EPPHC",
    enctalltyp_name:
      "Emergency Admission by referral from private primary healthcare center",
  },
  {
    enctalltyp_code: "EPH",
    enctalltyp_name: "Emergency Admission by referral from private hospital",
  },
  {
    enctalltyp_code: "EIC",
    enctalltyp_name: "Emergency Admission by insurance company",
  },
  {
    enctalltyp_code: "EWGS",
    enctalltyp_name: "Elective waiting list admission government free Scheme",
  },
  {
    enctalltyp_code: "EWSS",
    enctalltyp_name: "Elective waiting list admission self-payment Scheme",
  },
  {
    enctalltyp_code: "EWIS",
    enctalltyp_name:
      "Elective waiting list admission insurance coverage Scheme",
  },
  {
    enctalltyp_code: "EMBA",
    enctalltyp_name: "Emergency Maternity Birth Admission",
  },
  {
    enctalltyp_code: "PMBA",
    enctalltyp_name: "Planned Maternity Birth Admission",
  },
  {
    enctalltyp_code: "RECR",
    enctalltyp_name: "Red crescent",
  },
  {
    enctalltyp_code: "WKIN",
    enctalltyp_name: "Walk-in",
  },
  {
    enctalltyp_code: "FMLYM",
    enctalltyp_name: "Family Member",
  },
  {
    enctalltyp_code: "AA",
    enctalltyp_name: "Already Admitted",
  },
  {
    enctalltyp_code: "PVAMB",
    enctalltyp_name: "Private Ambulance",
  },
  {
    enctalltyp_code: "AAIC",
    enctalltyp_name: "Already admitted- insurance consumed",
  },
  {
    enctalltyp_code: "Others",
    enctalltyp_name: "Others",
  },
];

const intendLength = {
  ISD: "Intended same day",
  IO: "Intended overnight",
};

const serviceEvent = {
  ICSE: "Initial client service event",
  SCSE: "Subsequent client service event",
};

const encounterClasses = {
  AMB: "Ambulatory",
  EMER: "Emergency",
  HH: "Home Health",
  IMP: "In-Patient",
  SS: "Short Stay",
  VR: "Telemedicine",
  ACT: "Acute",
};

const admissionSpeciality = [
  {
    specialities_code: "01.00",
    specialities_name: "Anesthesiology Specialty",
  },
  {
    specialities_code: "01.01",
    specialities_name: "Ambulatory Anesthesia",
  },
  {
    specialities_code: "01.02",
    specialities_name: "Anesthesia Cardiology",
  },
  {
    specialities_code: "01.03",
    specialities_name: "Neuro-Anesthesia",
  },
  {
    specialities_code: "01.04",
    specialities_name: "Obstetrics Anesthesia ",
  },
  {
    specialities_code: "01.05",
    specialities_name: "Pediatrics Anesthesia",
  },
  {
    specialities_code: "01.06",
    specialities_name: "Pediatrics Cardiac Anesthesia ",
  },
  {
    specialities_code: "01.07",
    specialities_name: "Regional Anesthesia",
  },
  {
    specialities_code: "01.08",
    specialities_name: "Vascular / Thoracic Anesthesia",
  },
  {
    specialities_code: "02.00",
    specialities_name: "Community Medicine Specialty",
  },
  {
    specialities_code: "02.01",
    specialities_name: "Community Health",
  },
  {
    specialities_code: "03.00",
    specialities_name: "Dermatology Specialty",
  },
  {
    specialities_code: "03.01",
    specialities_name: "Dermatology Surgery ",
  },
  {
    specialities_code: "03.02",
    specialities_name: "Hair Implant Dermatology ",
  },
  {
    specialities_code: "03.03",
    specialities_name: "Pediatrics Dermatology ",
  },
  {
    specialities_code: "04.00",
    specialities_name: "Emergency Medicine Specialty ",
  },
  {
    specialities_code: "04.01",
    specialities_name: "Adult Emergency Medicine ",
  },
  {
    specialities_code: "04.02",
    specialities_name: "Pediatrics Emergency Medicine ",
  },
  {
    specialities_code: "05.00",
    specialities_name: "Ear, Nose & Throat Specialty ",
  },
  {
    specialities_code: "05.01",
    specialities_name: "Adult ENT",
  },
  {
    specialities_code: "05.02",
    specialities_name: "Laryngology",
  },
  {
    specialities_code: "05.03",
    specialities_name: "Neuro - Otology & Otology ",
  },
  {
    specialities_code: "05.04",
    specialities_name: "Nose, Ear Surgery ",
  },
  {
    specialities_code: "05.05",
    specialities_name: "Oral & Maxillofacial Surgery ",
  },
  {
    specialities_code: "05.06",
    specialities_name: "Otolaryngology",
  },
  {
    specialities_code: "05.07",
    specialities_name: "Pediatrics ENT ",
  },
  {
    specialities_code: "05.08",
    specialities_name: "Pediatrics Otolaryngology",
  },
  {
    specialities_code: "05.09",
    specialities_name: "Rhinology ",
  },
  {
    specialities_code: "05.10",
    specialities_name: "Audiology ",
  },
  {
    specialities_code: "06.00",
    specialities_name: "Family Medicine Specialty ",
  },
  {
    specialities_code: "06.01",
    specialities_name: "Family Medicine ",
  },
  {
    specialities_code: "06.02",
    specialities_name: "Primary Care / Ophthalmology ",
  },
  {
    specialities_code: "06.03",
    specialities_name: "Primary Care / Pulmonary ",
  },
  {
    specialities_code: "06.04",
    specialities_name: "Primary Care Preventive Pediatrics",
  },
  {
    specialities_code: "06.05",
    specialities_name: "Primary Health Care ",
  },
  {
    specialities_code: "07.00",
    specialities_name: "Forensic Medicine Specialty ",
  },
  {
    specialities_code: "08.00",
    specialities_name: "Internal Medicine Specialty ",
  },
  {
    specialities_code: "08.01",
    specialities_name: "Adolescent Medicine ",
  },
  {
    specialities_code: "08.02",
    specialities_name: "Cardiology ",
  },
  {
    specialities_code: "08.03",
    specialities_name: "Diabetics Medicine",
  },
  {
    specialities_code: "08.04",
    specialities_name: "Endocrinology ",
  },
  {
    specialities_code: "08.05",
    specialities_name: "Gastrology/Gastroenterology",
  },
  {
    specialities_code: "08.06",
    specialities_name: "Geriatrics ",
  },
  {
    specialities_code: "08.07",
    specialities_name: "Hematology ",
  },
  {
    specialities_code: "08.08",
    specialities_name: "Infectious Diseases ",
  },
  {
    specialities_code: "08.09",
    specialities_name: "Nephrology",
  },
  {
    specialities_code: "08.10",
    specialities_name: "Nuclear Medicine",
  },
  {
    specialities_code: "08.11",
    specialities_name: "Oncology ",
  },
  {
    specialities_code: "08.12",
    specialities_name: "Palliative Medicine ",
  },
  {
    specialities_code: "08.13",
    specialities_name: "Pulmonology/Chest Medicine ",
  },
  {
    specialities_code: "08.14",
    specialities_name: "Rheumatology ",
  },
  {
    specialities_code: "08.15",
    specialities_name: "Sleep Medicine ",
  },
  {
    specialities_code: "08.16",
    specialities_name: "Sport Medicine",
  },
  {
    specialities_code: "08.17",
    specialities_name: "Hepatology ",
  },
  {
    specialities_code: "08.18",
    specialities_name: "Neurology ",
  },
  {
    specialities_code: "08.19",
    specialities_name: "Radiation Oncology ",
  },
  {
    specialities_code: "08.20",
    specialities_name: "Diabetes Foot Care ",
  },
  {
    specialities_code: "08.21",
    specialities_name: "Head & Neck Oncology",
  },
  {
    specialities_code: "08.22",
    specialities_name: "Hematology - Stem Cell",
  },
  {
    specialities_code: "08.23",
    specialities_name: "Congenital Heart Disease ",
  },
  {
    specialities_code: "08.24",
    specialities_name: "Bariatric Medicine ",
  },
  {
    specialities_code: "08.25",
    specialities_name: "Cardiothoracic",
  },
  {
    specialities_code: "08.26",
    specialities_name: "General Medicine ",
  },
  {
    specialities_code: "09.00",
    specialities_name: "Microbiology Specialty ",
  },
  {
    specialities_code: "10.00",
    specialities_name: "Obstetrics & Gynecology Specialty ",
  },
  {
    specialities_code: "10.01",
    specialities_name: "Gynecology Oncology ",
  },
  {
    specialities_code: "10.02",
    specialities_name: "Infertility ",
  },
  {
    specialities_code: "10.03",
    specialities_name: "IVF",
  },
  {
    specialities_code: "10.04",
    specialities_name: "Perinatology ",
  },
  {
    specialities_code: "10.05",
    specialities_name: "Urogynecology ",
  },
  {
    specialities_code: "10.06",
    specialities_name: "Obstetrics ",
  },
  {
    specialities_code: "10.07",
    specialities_name: "Reproductive Endocrinology & Infertility ",
  },
  {
    specialities_code: "10.08",
    specialities_name: "Gynecology ",
  },
  {
    specialities_code: "10.09",
    specialities_name: "Maternal Fetal Medicine ",
  },
  {
    specialities_code: "11.00",
    specialities_name: "Ophthalmology Specialty ",
  },
  {
    specialities_code: "11.01",
    specialities_name: "Comprehensive Ophthalmology ",
  },
  {
    specialities_code: "11.02",
    specialities_name: "Diseases & Surgery of the Retina ",
  },
  {
    specialities_code: "11.03",
    specialities_name: "Glaucoma ",
  },
  {
    specialities_code: "11.04",
    specialities_name: "Neuro - Ophthalmology ",
  },
  {
    specialities_code: "11.05",
    specialities_name: "Ocular Oncology ",
  },
  {
    specialities_code: "11.06",
    specialities_name: "Oculoplastic ",
  },
  {
    specialities_code: "11.07",
    specialities_name: "Ophthalmology ",
  },
  {
    specialities_code: "11.08",
    specialities_name: "Pediatrics Ophthalmology & Strabismus ",
  },
  {
    specialities_code: "11.09",
    specialities_name: "Primary Care / Ophthalmology ",
  },
  {
    specialities_code: "11.10",
    specialities_name: "Uveitis / Medical Retina ",
  },
  {
    specialities_code: "11.11",
    specialities_name: "Optometric ",
  },
  {
    specialities_code: "11.12",
    specialities_name: "Anterior Segment ",
  },
  {
    specialities_code: "11.13",
    specialities_name: "Anaplastology ",
  },
  {
    specialities_code: "11.14",
    specialities_name: "Macular Dystrophy ",
  },
  {
    specialities_code: "11.15",
    specialities_name: "Abyplopia ",
  },
  {
    specialities_code: "11.16",
    specialities_name: "Ophthalmic Photography ",
  },
  {
    specialities_code: "12.00",
    specialities_name: "Orthopedic Specialty ",
  },
  {
    specialities_code: "12.01",
    specialities_name: "Oncology Orthopedic ",
  },
  {
    specialities_code: "12.02",
    specialities_name: "Orthopedic Surgery ",
  },
  {
    specialities_code: "12.03",
    specialities_name: "Pediatrics Orthopedic ",
  },
  {
    specialities_code: "12.04",
    specialities_name: "Upper Limp Orthopedic",
  },
  {
    specialities_code: "13.00",
    specialities_name: "Pathology Specialty ",
  },
  {
    specialities_code: "13.01",
    specialities_name: "Bone & Soft Tissue Pathology ",
  },
  {
    specialities_code: "13.02",
    specialities_name: "Dermatopathology ",
  },
  {
    specialities_code: "13.03",
    specialities_name: "Gast. & Hepat Pathology",
  },
  {
    specialities_code: "13.04",
    specialities_name: "Histopathology ",
  },
  {
    specialities_code: "13.05",
    specialities_name: "Lymphoma Pathology",
  },
  {
    specialities_code: "13.06",
    specialities_name: "Pathology Dermatology ",
  },
  {
    specialities_code: "13.07",
    specialities_name: "Renal Pathology",
  },
  {
    specialities_code: "14.00",
    specialities_name: "Pediatric Specialty",
  },
  {
    specialities_code: "14.01",
    specialities_name: "Fetal Medicine ",
  },
  {
    specialities_code: "14.02",
    specialities_name: "Neonatal Intensive Care (NICU)",
  },
  {
    specialities_code: "14.03",
    specialities_name: "Pediatrics Imaging ",
  },
  {
    specialities_code: "14.04",
    specialities_name: "Pediatrics Endocrinology ",
  },
  {
    specialities_code: "14.05",
    specialities_name: "Pediatrics Gastroenterology ",
  },
  {
    specialities_code: "14.06",
    specialities_name: "Pediatrics Genetics ",
  },
  {
    specialities_code: "14.07",
    specialities_name: "Pediatrics Rheumatology",
  },
  {
    specialities_code: "14.08",
    specialities_name: "Pediatrics Sleep Medicine ",
  },
  {
    specialities_code: "14.09",
    specialities_name: "Pediatrics Orthopedic",
  },
  {
    specialities_code: "14.10",
    specialities_name: "Pediatrics Hematology ",
  },
  {
    specialities_code: "14.11",
    specialities_name: "Pediatrics Infectious Diseases",
  },
  {
    specialities_code: "14.12",
    specialities_name: "Pediatrics Intensive Care ",
  },
  {
    specialities_code: "14.13",
    specialities_name: "Pediatrics Nephrology",
  },
  {
    specialities_code: "14.14",
    specialities_name: "Pediatrics Pulmonary Diseases ",
  },
  {
    specialities_code: "14.15",
    specialities_name: "Primary Care Preventive Pediatrics ",
  },
  {
    specialities_code: "14.16",
    specialities_name: "Pediatric Neurology",
  },
  {
    specialities_code: "14.17",
    specialities_name: "Fetal Cardiology",
  },
  {
    specialities_code: "14.18",
    specialities_name: "Neonatology ",
  },
  {
    specialities_code: "14.19",
    specialities_name: "Pediatric Allergy ",
  },
  {
    specialities_code: "14.20",
    specialities_name: "Pediatric Cardiology",
  },
  {
    specialities_code: "15.00",
    specialities_name: "Pediatrics Surgery Specialty",
  },
  {
    specialities_code: "15.01",
    specialities_name: "Pediatrics Cardiology ",
  },
  {
    specialities_code: "15.02",
    specialities_name: "Pediatrics Neurosurgery ",
  },
  {
    specialities_code: "15.03",
    specialities_name: "Pediatrics Oncology ",
  },
  {
    specialities_code: "15.04",
    specialities_name: "Pediatrics Plastic Surgery ",
  },
  {
    specialities_code: "15.05",
    specialities_name: "Pediatrics General Surgery ",
  },
  {
    specialities_code: "15.06",
    specialities_name: "Pediatrics Hematology/Oncology ",
  },
  {
    specialities_code: "16.00",
    specialities_name: "Physical Medicine & Rehabilitation Specialty ",
  },
  {
    specialities_code: "16.01",
    specialities_name: "Physical Medicine & Rehabilitation ",
  },
  {
    specialities_code: "16.02",
    specialities_name: "Occupational Medicine",
  },
  {
    specialities_code: "17.00",
    specialities_name: "Psychiatry Specialty ",
  },
  {
    specialities_code: "17.01",
    specialities_name: "Addiction Medicine ",
  },
  {
    specialities_code: "17.02",
    specialities_name: "Child / Adolescent Psychiatry ",
  },
  {
    specialities_code: "17.03",
    specialities_name: "Consultation - Liaison Psychiatry ",
  },
  {
    specialities_code: "17.04",
    specialities_name: "Forensic Psychiatry ",
  },
  {
    specialities_code: "17.05",
    specialities_name: "Geriatric Psychiatry ",
  },
  {
    specialities_code: "17.06",
    specialities_name: "Mental Health ",
  },
  {
    specialities_code: "17.07",
    specialities_name: "Mood Disorders Psychiatry ",
  },
  {
    specialities_code: "17.08",
    specialities_name: "Psychiatry",
  },
  {
    specialities_code: "17.09",
    specialities_name: "Rehabilitation Psychiatry ",
  },
  {
    specialities_code: "17.10",
    specialities_name: "Schizophrenia",
  },
  {
    specialities_code: "17.11",
    specialities_name: "Pediatric Behavior ",
  },
  {
    specialities_code: "17.12",
    specialities_name: "Youth Stress Reduction ",
  },
  {
    specialities_code: "18.00",
    specialities_name: "Radiology Specialty ",
  },
  {
    specialities_code: "18.01",
    specialities_name: "Body Imaging ",
  },
  {
    specialities_code: "18.02",
    specialities_name: "Breast Imaging ",
  },
  {
    specialities_code: "18.03",
    specialities_name: "Cardiac Imaging ",
  },
  {
    specialities_code: "18.04",
    specialities_name: "Chest Imaging ",
  },
  {
    specialities_code: "18.05",
    specialities_name: "Diagnostic Neuroradiology",
  },
  {
    specialities_code: "18.06",
    specialities_name: "Diagnostic Radiology",
  },
  {
    specialities_code: "18.07",
    specialities_name: "Emergency Radiology ",
  },
  {
    specialities_code: "18.08",
    specialities_name: "Interventional Neuroradiology ",
  },
  {
    specialities_code: "18.09",
    specialities_name: "Interventional Radiology ",
  },
  {
    specialities_code: "18.10",
    specialities_name: "Musculoskeletal Imaging ",
  },
  {
    specialities_code: "18.11",
    specialities_name: "Pediatrics Imaging ",
  },
  {
    specialities_code: "18.12",
    specialities_name: "Womens Imaging",
  },
  {
    specialities_code: "19.00",
    specialities_name: "Surgery Specialty ",
  },
  {
    specialities_code: "19.01",
    specialities_name: "Arthroplasty Surgery ",
  },
  {
    specialities_code: "19.02",
    specialities_name: "Bariatric Surgery ",
  },
  {
    specialities_code: "19.03",
    specialities_name: "Cosmetic Surgery ",
  },
  {
    specialities_code: "19.04",
    specialities_name: "Craniofacial Surgery ",
  },
  {
    specialities_code: "19.05",
    specialities_name: "Endocrinology Surgery ",
  },
  {
    specialities_code: "19.06",
    specialities_name: "Facioplastic ",
  },
  {
    specialities_code: "19.07",
    specialities_name: "Foot & Ankle Surgery ",
  },
  {
    specialities_code: "19.08",
    specialities_name: "General Surgery ",
  },
  {
    specialities_code: "19.09",
    specialities_name: "Hand Surgery ",
  },
  {
    specialities_code: "19.10",
    specialities_name: "Hepatobiliary & Upper GI Surgery ",
  },
  {
    specialities_code: "19.11",
    specialities_name: "Neurosurgery (Spinal Surgery) ",
  },
  {
    specialities_code: "19.12",
    specialities_name: "Neurosurgery / Oncology ",
  },
  {
    specialities_code: "19.13",
    specialities_name: "Neurosurgery Vascular ",
  },
  {
    specialities_code: "19.14",
    specialities_name: "Plastic Surgery & Reconstruction ",
  },
  {
    specialities_code: "19.15",
    specialities_name: "Skull Base Surgery ",
  },
  {
    specialities_code: "19.16",
    specialities_name: "Spine Surgery",
  },
  {
    specialities_code: "19.17",
    specialities_name: "Thoracic Surgery/Chest Surgery ",
  },
  {
    specialities_code: "19.18",
    specialities_name: "Trauma Surgery",
  },
  {
    specialities_code: "19.19",
    specialities_name: "Vascular Surgery ",
  },
  {
    specialities_code: "19.20",
    specialities_name: "Colorectal Surgery ",
  },
  {
    specialities_code: "19.21",
    specialities_name: "Transplant Surgery ",
  },
  {
    specialities_code: "19.22",
    specialities_name: "Liver Transplant Surgery ",
  },
  {
    specialities_code: "19.23",
    specialities_name: "Renal and Pancreas Transplant Surgery ",
  },
  {
    specialities_code: "19.24",
    specialities_name: "Breast Surgery ",
  },
  {
    specialities_code: "19.25",
    specialities_name: "Cardiothoracic Surgery ",
  },
  {
    specialities_code: "19.26",
    specialities_name: "Burns",
  },
  {
    specialities_code: "20.00",
    specialities_name: "Urology Specialty ",
  },
  {
    specialities_code: "20.01",
    specialities_name: "Gynecology Urology ",
  },
  {
    specialities_code: "20.02",
    specialities_name: "Laparoscopic Urology ",
  },
  {
    specialities_code: "20.03",
    specialities_name: "Neuro - Urology ",
  },
  {
    specialities_code: "20.04",
    specialities_name: "Oncology Urology ",
  },
  {
    specialities_code: "20.05",
    specialities_name: "Pediatrics Urology ",
  },
  {
    specialities_code: "20.06",
    specialities_name: "Reconstruction Urology",
  },
  {
    specialities_code: "21.00",
    specialities_name: "Critical Care ",
  },
  {
    specialities_code: "21.01",
    specialities_name: "Pediatric Critical Care (PICU) ",
  },
  {
    specialities_code: "21.02",
    specialities_name: "Intensive Care (ICU) ",
  },
  {
    specialities_code: "22.00",
    specialities_name: "Dental",
  },
  {
    specialities_code: "22.01",
    specialities_name: "Pediatric Dental",
  },
  {
    specialities_code: "22.02",
    specialities_name: "Prosthodontics ",
  },
  {
    specialities_code: "22.03",
    specialities_name: "Endodontics ",
  },
  {
    specialities_code: "22.04",
    specialities_name: "Periodontics ",
  },
  {
    specialities_code: "22.05",
    specialities_name: "Orthodontics",
  },
  {
    specialities_code: "22.06",
    specialities_name: "Dental Implants ",
  },
  {
    specialities_code: "22.07",
    specialities_name: "Dental Hygiene ",
  },
  {
    specialities_code: "22.08",
    specialities_name: "Special Needs Dentistry ",
  },
  {
    specialities_code: "23.00",
    specialities_name: "Neurophysiology",
  },
  {
    specialities_code: "24.00",
    specialities_name: "Speech/Speech Language Pathology ",
  },
  {
    specialities_code: "25.00",
    specialities_name: "Infection Control ",
  },
];
